const CUSTOM_AREA_TYPES = ['polygon', 'circle', 'walking'] as const;

const MIN_RADIUS = 0.1;
const MAX_RADIUS = 100;

const NUMBER_OF_POINTS_FOR_CIRCLE = 16;

const MIN_MINUTES = 1;
const DEFAULT_MINUTES = 5;
const MAX_MINUTES = 30;

const MIN_TOLERANCE = 0.0001;
const MAX_TOLERANCE = 0.003;

const isValidRadius = (radius: string | number): boolean => {
  if (typeof radius === 'number') {
    return MIN_RADIUS <= radius && radius <= MAX_RADIUS;
  }
  return (
    radius.trim() !== '' &&
    !Number.isNaN(Number(radius)) &&
    MIN_RADIUS <= Number(radius) &&
    Number(radius) <= MAX_RADIUS
  );
};

const isValidMinutes = (minutes: string | number): boolean => {
  if (typeof minutes === 'number') {
    return MIN_MINUTES <= minutes && minutes <= MAX_MINUTES;
  }
  return (
    minutes.trim() !== '' &&
    !Number.isNaN(Number(minutes)) &&
    MIN_MINUTES <= Number(minutes) &&
    Number(minutes) <= MAX_MINUTES
  );
};

export {
  CUSTOM_AREA_TYPES,
  MIN_RADIUS,
  MAX_RADIUS,
  NUMBER_OF_POINTS_FOR_CIRCLE,
  MIN_MINUTES,
  DEFAULT_MINUTES,
  MAX_MINUTES,
  MIN_TOLERANCE,
  MAX_TOLERANCE,
  isValidRadius,
  isValidMinutes,
};
